export interface ArticleDetail {
  slug: string;
  title: string;
  subtitle: string;
  category: string;
  categorySlug: string;
  author: string;
  publishDate: string;
  heroImage: string;
  content: string[];
  tags: string[];
  heat: string;
  views: string;
  isVerified: boolean;
}

export interface Comment {
  id: string;
  author: string;
  avatar: string;
  rating: number;
  title: string;
  content: string;
  timeAgo: string;
}

export const articleDetails: Record<string, ArticleDetail> = {
  'top-streamer-tax-evasion-2026': {
    slug: 'top-streamer-tax-evasion-2026',
    title: '某顶流主播涉嫌偷税漏税2.3亿，已被税务部门依法调查取证',
    subtitle: '据知情人士透露，该主播近三年通过多个壳公司转移收入，目前案件已进入司法程序，或面临巨额罚款及刑事责任。',
    category: '网红黑料',
    categorySlug: 'influencer-scandal',
    author: '911爆料编辑部',
    publishDate: '2026年7月6日 14:30',
    heroImage: 'https://readdy.ai/api/search-image?query=Dark%20ominous%20financial%20documents%20with%20red%20stamp%20and%20dramatic%20lighting%2C%20breaking%20news%20editorial%20photography%2C%20deep%20shadows%2C%20mysterious%20cinematic%20composition%2C%20no%20people&width=1600&height=700&seq=article-detail-tax-evasion&orientation=landscape',
    content: [
      '近日，据国家税务总局稽查局内部人士透露，某平台粉丝量超3000万的顶流带货主播因涉嫌偷逃税款，已被税务部门依法正式立案调查。据悉，该主播近三年通过设立多家壳公司、伪造交易记录等方式，累计逃避个人所得税及增值税合计高达2.3亿元人民币。',
      '知情人士向911爆料网透露，该主播在2023年至2025年期间，通过其亲属及助理名义注册了超过15家空壳公司，分布在霍尔果斯、上海崇明等多个税收优惠地区。这些公司表面从事广告策划、品牌营销等业务，实际并无任何真实经营活动，仅用于转移和隐匿其直播带货及品牌代言所获得的巨额收入。',
      '更为恶劣的是，调查人员发现该主播还涉嫌伪造进项发票。通过购买虚开的增值税专用发票来抵扣销项税额，涉及的发票金额超过8000万元。此举不仅严重违反了《中华人民共和国税收征收管理法》，更已触及刑法的红线。',
      '目前，案件已移交司法机关处理。据接近案件的人士透露，该主播不仅面临补缴税款、加收滞纳金和罚款等行政处罚，还可能因涉嫌逃税罪面临三年以上七年以下有期徒刑。其合作的多个品牌方已在第一时间宣布暂停与该主播的一切商业合作。',
      '此事一经曝光即在网络引发轩然大波。众多网友对该主播的行为表示愤怒和失望。一位自称是该主播多年粉丝的网友在社交平台表示："一直以为他是白手起家的励志典范，没想到赚了这么多钱还在偷税漏税，太让人寒心了。"',
      '业内人士分析认为，此案可能成为2026年直播带货行业的标志性事件。随着税务监管的日益严格和"金税四期"系统的全面上线，直播行业的高收入群体将面临更加严格的税收审查。行业洗牌在所难免，合规经营将成为从业者的基本底线。',
      '截至发稿前，该主播的社交账号已处于禁言状态，其所属直播平台也发布公告称将全力配合有关部门的调查工作。911爆料网将持续关注此案的最新进展。',
    ],
    tags: ['偷税漏税', '顶流主播', '税务调查', '壳公司', '虚开发票'],
    heat: '986.5w',
    views: '156.2w',
    isVerified: true,
  },
  'idol-group-internal-bullying': {
    slug: 'idol-group-internal-bullying',
    title: '某偶像团体内部霸凌录音曝光，经纪公司紧急发声明否认',
    subtitle: '一段长达23分钟的录音在社交平台疯传，涉及某当红男团内部成员之间的激烈争吵与人身攻击，粉丝群体已炸锅。',
    category: '明星塌房',
    categorySlug: 'celebrity-downfall',
    author: '911爆料编辑部',
    publishDate: '2026年7月6日 11:00',
    heroImage: 'https://readdy.ai/api/search-image?query=Dark%20empty%20concert%20stage%20with%20dramatic%20crimson%20spotlight%2C%20mysterious%20atmosphere%2C%20editorial%20cinematic%20photography%2C%20no%20people%2C%20tense%20mood&width=1600&height=700&seq=article-detail-idol-bullying&orientation=landscape',
    content: [
      '7月6日凌晨，一段据称是某当红偶像男团练习室内部的录音在各大社交平台疯传，短短数小时内播放量突破千万。在这段长达23分钟的录音中，可以清晰听到多名男性成员之间的激烈争吵，内容涉及人身攻击、资源分配不公以及对某位成员的集体孤立和嘲讽。',
      '录音中，一位声音被网友识别为队长的成员，用极具攻击性的语言指责另一成员"拖后腿"、"没有你就好了"。其他几位成员非但没有劝阻，反而附和起哄。被攻击的成员声音颤抖，多次试图解释但均被打断，最后录音以该成员的哭泣声结束。',
      '录音泄露后，该男团的粉丝群体瞬间炸锅。大量粉丝涌入经纪公司官方账号评论区要求给出解释。部分粉丝开始自发组织"保护行动"，呼吁经纪公司对被霸凌成员给予保护和心理疏导。但同时也有一批"唯粉"开始互相指责，称录音是被恶意剪辑和断章取义。',
      '面对愈演愈烈的舆论风波，经纪公司于当日上午紧急发布声明，称"网传录音内容严重失实，系不法分子通过AI音频合成技术恶意伪造，公司已向公安机关报案并将追究造谣者的法律责任"。然而，多位音频技术专家在听过录音后表示，录音中的人声特征与成员公开的语音高度吻合，AI合成的可能性极低。',
      '资深娱乐记者透露，该男团内部不和的消息在圈内早已不是秘密。团内资源分配严重不均，队长和另外两名"皇族"成员几乎垄断了所有个人代言和综艺资源，而其他成员长期处于被边缘化的状态。此次录音事件只是长期矛盾积累后的集中爆发。',
      '截至目前，事件涉及的各位成员均未对外发声，个人社交账号也未见更新。多个已官宣的品牌代言活动已紧急叫停。业内人士担忧，如果录音内容被证实为真，这个曾经创下多项销量纪录的顶流男团可能面临解散危机。',
    ],
    tags: ['偶像团体', '霸凌', '录音曝光', '男团', 'AI音频'],
    heat: '872.3w',
    views: '134.6w',
    isVerified: true,
  },
  'a-list-actress-affair-scandal': {
    slug: 'a-list-actress-affair-scandal',
    title: '一线女星被拍到深夜与已婚导演幽会，六小时未出酒店引发全网热议',
    subtitle: '狗仔队蹲守多日终于拍到实锤画面，视频中清晰可见两人前后进入同一酒店房间，男方妻子已取关该女星所有社交账号。',
    category: '明星塌房',
    categorySlug: 'celebrity-downfall',
    author: '911爆料编辑部',
    publishDate: '2026年7月5日 22:00',
    heroImage: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20hotel%20exterior%20at%20night%20with%20dramatic%20cinematic%20lighting%2C%20deep%20shadows%2C%20mysterious%20editorial%20photography%2C%20no%20people%20visible&width=1600&height=700&seq=article-detail-hotel-affair&orientation=landscape',
    content: [
      '7月5日晚间，知名娱乐狗仔团队"追光工作室"发布了一段据称拍摄于三天前的跟踪视频。视频显示，某一线女演员（经网友比对确认为近两年凭借多部热门剧集跻身一线的Z姓女星）于深夜11点左右独自驾车来到北京某五星级酒店地下停车场。',
      '约15分钟后，一位男子（据网友比对为已有家室的知名导演W某）出现在画面中，两人在电梯口短暂交谈后，一前一后进入同一楼层。狗仔队通过酒店内部人士确认，两人进入了同一间套房。直到次日凌晨5时许，两人才先后离开酒店，在房间内共处时间超过六小时。',
      '视频发布后迅速登顶各大平台热搜。更引人注目的是，导演W某的妻子的社交账号在视频发布后不到一小时内，取关了Z姓女星的所有社交账号，并删除了一条此前与Z姓女星互动的内容。这一举动被网友视为"默认了丈夫出轨事实"的信号。',
      '据圈内人士透露，Z姓女星与W导的合作始于2024年的一部都市情感剧。该剧拍摄期间，剧组内部就多次传出两人关系暧昧的消息。当时有工作人员匿名爆料称两人经常在收工后单独相处，但被双方团队以"正常讨论剧本"为由否认。',
      '截至目前，涉事三方均未对此事作出公开回应。Z姓女星的经纪团队媒体电话一直处于无人接听状态。而W导方面，其工作室仅简短回复"私事不便回应"。法律界人士表示，如果两人确实存在婚外情关系，W导的行为已构成婚姻过错，其配偶有权在离婚诉讼中主张损害赔偿。',
      '此次事件在网络上引发了关于"明星道德底线"的广泛讨论。多位网友表示，作为公众人物，明星的一言一行都具有示范效应，婚内出轨不仅伤害了家人，也对青少年粉丝群体造成了不良影响。',
    ],
    tags: ['一线女星', '婚外情', '酒店幽会', '已婚导演', '狗仔实锤'],
    heat: '721.4w',
    views: '108.9w',
    isVerified: true,
  },
  'beauty-blogger-fake-products': {
    slug: 'beauty-blogger-fake-products',
    title: '百万粉丝美妆博主被曝卖假货，成本30卖980，受害者集体维权',
    subtitle: '多名消费者提供检测报告证实该博主推荐的"自主研发"产品成分与宣传严重不符，已有多地市场监管部门介入。',
    category: '网红黑料',
    categorySlug: 'influencer-scandal',
    author: '911爆料编辑部',
    publishDate: '2026年7月5日 18:00',
    heroImage: 'https://readdy.ai/api/search-image?query=Dark%20elegant%20cosmetics%20on%20black%20marble%20with%20dramatic%20spotlight%2C%20luxury%20beauty%20editorial%20photography%2C%20deep%20shadows%2C%20mysterious%20atmosphere&width=1600&height=700&seq=article-detail-fake-beauty&orientation=landscape',
    content: [
      '近日，拥有超过百万粉丝的美妆博主"XX酱"（化名）被大批消费者集体曝光，指控其自主品牌的多款产品涉嫌虚假宣传和售卖假冒伪劣商品。据911爆料网记者调查，该博主名下品牌的一款"胶原蛋白精华液"标价980元/瓶，但实际生产成本据业内人士估算不足30元。',
      '最早发现问题的是一位化学专业的大学生消费者。她将该产品送至第三方检测机构进行成分分析，检测报告显示，产品中的"胶原蛋白"含量几乎为零，主要成分为水和增稠剂，与产品宣传中的"高浓度活性胶原蛋白"严重不符。她将检测报告发布到社交平台后，迅速引发了大量购买了同款产品的消费者的共鸣。',
      '据初步统计，目前已有超过500名消费者加入了维权群。多位消费者晒出了各自的检测报告，结果均指向同样的结论：产品成分与宣传严重不符。更有消费者反映使用后出现了皮肤过敏、红肿等不良反应，但向该博主反馈后不仅没有得到合理解决，反而被拉黑处理。',
      '记者调查发现，该博主名下品牌的实际生产方为广州某小型代工厂，该工厂此前曾因生产不合格化妆品被市场监管部门多次处罚。而该博主在直播间中反复强调产品为"自主研发、自有工厂生产"，明显存在虚假宣传行为。',
      '目前，已有来自北京、上海、广州、成都等多地的市场监管部门接到了消费者的举报投诉，并已正式立案调查。法律界人士指出，如果查实该博主的行为构成欺诈，其不仅要承担退一赔三的民事责任，还可能因涉嫌生产销售伪劣产品罪面临刑事追诉。',
      '该博主在事件发酵后已暂停直播并清空了所有产品链接，但截至发稿前仍未对消费者的维权诉求作出正面回应。911爆料网提醒广大消费者，在购买网红推荐产品时需保持理性，切勿盲目跟风消费。',
    ],
    tags: ['美妆博主', '假货', '消费者维权', '成分检测', '市场监管'],
    heat: '765.8w',
    views: '112.3w',
    isVerified: true,
  },
};

export const commentsList: Comment[] = [
  { id: 'c1', author: '吃瓜第一线', avatar: '', rating: 5, title: '这瓜保熟，实锤得不能再实了', content: '作为业内人士我可以确认，这个主播的问题早就被盯上了。金税四期上线后，所有高收入直播都会被自动扫描，根本藏不住。2.3亿这个数字可能还只是冰山一角，后续可能还有更多料爆出来。', timeAgo: '1小时前' },
  { id: 'c2', author: '理性吃瓜群众', avatar: '', rating: 4, title: '希望依法处理，给行业一个警示', content: '不管是谁，偷税漏税就是违法，就应该受到法律制裁。直播行业这几年野蛮生长，是该好好整顿了。希望这次能起到杀一儆百的效果。', timeAgo: '2小时前' },
  { id: 'c3', author: '老娱乐圈八卦', avatar: '', rating: 5, title: '终于有人扒这个了', content: '之前我就说过这个主播有问题，一年赚几个亿居然只交那么点税？稍微懂点财务的人都能看出来不正常。这次算是彻底翻车了，品牌方解约是对的。', timeAgo: '3小时前' },
  { id: 'c4', author: '正义不会缺席', avatar: '', rating: 5, title: '活该！偷税漏税必须严惩', content: '普通打工人每个月老老实实交税，这些赚几亿的人却想方设法逃税？支持税务部门依法查处，该抓就抓，该罚就罚，别因为是"名人"就网开一面。', timeAgo: '4小时前' },
  { id: 'c5', author: '默默看戏', avatar: '', rating: 3, title: '等官方通报再下结论', content: '虽然目前证据很充分，但还是等官方正式通报吧。不过说实话，如果被立案调查了，那基本上是八九不离十了。就看最后怎么判了。', timeAgo: '5小时前' },
  { id: 'c6', author: '瓜田里的猹', avatar: '', rating: 4, title: '又一个翻车的，今年第几个了？', content: '今年网红翻车的频率也太高了，前有假货带货，后有慈善诈骗，现在又是偷税漏税。感觉每隔几天就有一个大瓜。只能说，不作死就不会死。', timeAgo: '6小时前' },
];

export const defaultComment: Comment[] = [
  { id: 'd1', author: '热心的吃瓜群众', avatar: '', rating: 4, title: '这个瓜有意思，持续关注中', content: '细节越扒越多，感觉背后还有更大的料没爆出来。蹲一个后续发展，希望911爆料网能继续深挖！', timeAgo: '刚刚' },
  { id: 'd2', author: '资深八卦达人', avatar: '', rating: 5, title: '信息量很大，建议仔细阅读', content: '认真看完了全文，有几个细节值得深究。特别是时间线上的矛盾，感觉当事方的说法前后不一致。建议编辑能把时间线梳理得更清楚一些。', timeAgo: '30分钟前' },
  { id: 'd3', author: '理性分析者', avatar: '', rating: 3, title: '让子弹再飞一会儿', content: '目前的信息还不足以完全定性，建议大家在官方调查结果出来之前保持理性，不传谣不信谣。不过从目前公开的信息来看，情况确实不太乐观。', timeAgo: '1小时前' },
  { id: 'd4', author: '真相只有一个', avatar: '', rating: 5, title: '已分享给朋友一起吃瓜', content: '这个爆料太劲爆了！已经转发到好几个群里了，大家都在讨论。911爆料网真的是吃瓜第一线，比那些只会抄来抄去的营销号强太多了。', timeAgo: '2小时前' },
  { id: 'd5', author: '键盘侠在行动', avatar: '', rating: 4, title: '有理有据，令人信服', content: '文章写得不错，引用了多方信源，逻辑也比较清晰。比那些标题党好太多了。希望以后能保持这个质量水准，持续产出高质量的吃瓜内容。', timeAgo: '3小时前' },
  { id: 'd6', author: '深夜吃瓜人', avatar: '', rating: 4, title: '熬夜追完，值了', content: '大半夜刷到这个瓜，一口气看完了全文和评论区。信息量确实大，明天上班估计要迟到了。但值！这种一手爆料真的太难得了。', timeAgo: '4小时前' },
];